export const DEFAULT_LABEL = 'Official Only';
export const DEFAULT_TOOLTIP_TITLE =
  'If checked, documents with no official publication date will be excluded from the search';
